export const SIMULATED_SYNC_DELAY_MS = 600;


export const API = {
  GET_KNOWLEDGE_BASE_ROWS: {
      // Backend should accept pagination + optional filters in the body.
      // Payload includes: { productId?, page?, limit?, skip?, query? }
    path: '/kb-sources/get-kb-paginated',
    method: 'POST',
  },

  SYNC_KNOWLEDGE_BASE: {
    path: '/kb-sources/qrtiger-auto-create-kb-sources',
    method: 'GET',
  },
};